import React from "react"; 
import Sidebar from "../../../components/Sidebar"; 

const NoanotherDelivery: React.FC = () =>{
return(
     <div className="container-fluid">
      <div className="row">
        <Sidebar />
        <div className="col-lg-9 col-12 content-area">
          <div className="row">
            <div className="col-md-8 py-5 box">
              <div className=" h-100 card-secondary px-lg-5 py-5">
                <h4 className="text-center mt-3 py-2">Your Delivery is Completed</h4>
               <h6 className="text-center mt-3 py-2">No additional deliveries are assigned right now</h6>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
);

};

export default  NoanotherDelivery;